export default __webpack_public_path__ + "static/media/loader.f0a5a7ad.svg";